const Style = {
  base: 'relative',
  button:
    'absolute top-1/2 right-4 cursor-pointer opacity-50 -translate-y-1/2 ease-in-out duration-300 hover:opacity-100',
}

export default Style
